import React from 'react';

interface TabData {
  Value(Value: any, arg1: string): React.ReactNode;
  key: number;
  id: number;
  name: string;
  content: React.ReactNode;
}

interface SleekTabProps {
  selectedTab: number;
  tabData: TabData[];
  handleChangeTab: (id: number) => void;
  ContainerClass: string;
  tabDataValue: any;
  tabDataLable: any;
  isShowNumber: boolean;
  showNumberData: any;
  showNumberLable: any;
}

const SleekTab: React.FC<SleekTabProps> = ({
  selectedTab,
  tabData,
  handleChangeTab,
  ContainerClass,
  tabDataValue = 'id',
  tabDataLable = 'name',
  showNumberLable = 'name',
  isShowNumber = false,
  showNumberData,
}) => {
  return (
    <div>
      {/* <div className="sleek_tab">
        {tabData?.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleChangeTab(tab.id)}
            className={`${selectedTab === tab.id ? 'active' : ''} crm_sub_head_design_without_colour crm_bg_black`}
          >
            {tab.name}
          </button>
        ))}
      </div>
      <div className="tab-content">
        {tabData?.map((tab) => selectedTab === tab.id && <div key={tab.id}>{tab.content}</div>)}
      </div> */}

      <div
        className={`d-flex   crm_small_tab_main_desing ${ContainerClass}   crm_border_botton_desgin_hr sleek_tab`}
      >
        {tabData?.map((tab, index) => (
          <div
            key={tab[tabDataValue]}
            className={`crm_tab_2_padding_design crm_cursor_pointer d-flex align-items-center ${selectedTab === tab[tabDataValue] && 'crm_tab_2_selected_design '} `}
            style={{
              height: '30px',
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleChangeTab(tab?.[tabDataValue]);
            }}
          >
            {tab[tabDataLable]} {/* { && <div>bl</div>} */}
            {tab?.key === 10 && Object.values(showNumberData).flat()?.length > 0 && (
              <div
                style={{
                  marginLeft: '5px',
                  backgroundColor: '#753CB7',
                  borderRadius: '50%',
                  width: '16px',
                  height: '16px',
                  fontSize: '12px',
                  color: '#ffffff',
                }}
                className="d-flex align-items-center justify-content-center"
              >
                {Object.values(showNumberData).flat()?.length}
              </div>
            )}
            {isShowNumber &&
              showNumberData[tab[showNumberLable]]?.length > 0 &&
              tab?.key !== 10 && (
                <div
                  style={{
                    marginLeft: '5px',
                    backgroundColor: '#753CB7',
                    borderRadius: '50%',
                    width: '16px',
                    height: '16px',
                    fontSize: '12px',
                    color: '#ffffff',
                  }}
                  className="d-flex align-items-center justify-content-center"
                >
                  {showNumberData[tab[showNumberLable]]?.length}
                </div>
              )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SleekTab;
